(ns frontend.view.reports.custom.panostaja
  (:require [frontend.state.current-session :as session]
            [frontend.bootstrap.components :as rbs]
            [common.localization :as loc]
            [frontend.actions.excel-export :as excel-export]
            [frontend.view.components.clipboard :as clipboard]
            [frontend.view.reports.events :as events]
            [reagent.core :as r]
            [clojure.string :as string]
            [common.util :as cu]
            [common.entity :as entity]
            [frontend.utils :as fu]
            [common.date-formats :as date-formats]
            [frontend.logging :as logging]
            [common.timezones :as timezones]
            [frontend.exports.excel :as excel]
            [frontend.zap-time :as zap-time]
            [ui.components.card.view :as card]))

(defonce default-params {:quarter-count            4
                         :include-ongoing-quarter? true
                         :quarter-monthshift       0})
(defonce custom-params {:quarter-count            4
                        :include-ongoing-quarter? true
                        :quarter-monthshift       -2})      ;; custom timeshift for panostaja

(defonce reports [[:quarterly-data default-params]
                  [:quarterly-data custom-params]])

(defn report-view [view-name quarterly-data]
  (let [quarters (some->> quarterly-data
                          (first)                           ;; first report
                          (second)                          ;; data
                          (map (fn [[qn data]]
                                 [qn (select-keys data [:start-millis :end-millis])]))
                          (into {}))
        quarter-names (some->> quarters
                               (map first)                  ;; quarter-name
                               (sort-by (fn [q]
                                          (->> q
                                               (cu/flip string/split #"Q")
                                               (reverse)
                                               (string/join "Q")))))
        export-atom (atom [(concat [""] quarter-names)])
        df (or (:tenant/date-format @session/tenant) (loc/tr :date-format))
        tz (or (:tenant/timezone @session/tenant) timezones/default-timezone)
        todays-date (date-formats/format-millis (zap-time/now)
                                                (or (:tenant/date-format @session/tenant) (loc/tr :date-format))
                                                (or (:tenant/timezone @session/tenant) timezones/default-timezone))]
    [card/card
     [card/header
      [:span view-name]
      [:div.d-flex.justify-content-end
       [:i.fal.fa-copy.mr-3.pointer
        {:title    (loc/tr :copy-to-clipboard)
         :on-click (fn [_]
                     (clipboard/copy-as-tsv @export-atom))}]
       [:i.fal.fa-file-excel
        {:title    (loc/tr :save-as-excel)
         :on-click (fn [_]
                     (excel/export-array-data (loc/tr :export-filename-panostaja [todays-date])
                                              @export-atom))}]]]
     [card/body
      [:table.zap-simple-table.zap-simple-table--sm.w-100
       [:thead
        [:tr
         [:th.col-heading]
         (for [q-name quarter-names]
           [:th.col-heading
            {:key (str "quarterly-reports-label-" q-name)}
            q-name])]
        (let [header-row-atom (atom [""])
              hiccup [:tr
                      [:th.col-heading]
                      (doall (for [q-name quarter-names
                                   :let [q-data (->> quarters
                                                     (filter (fn [[qn info]]
                                                               (= qn q-name)))
                                                     (first)
                                                     (second)) ;; info
                                         {:keys [start-millis end-millis]} q-data]]
                               [:th
                                {:key        (str "quarterly-reports-date-" q-name)
                                 :class-name (fu/cs "col-heading" "sub-heading")}
                                (let [date-range-str (str (date-formats/format-millis start-millis df tz)
                                                          "-"
                                                          (date-formats/format-millis end-millis df tz))]
                                  (swap! header-row-atom concat [date-range-str])
                                  date-range-str)
                                ]))]
              _ (swap! export-atom concat [@header-row-atom])]
          hiccup)]

       (doall (for [[report-key report-data-map] quarterly-data
                    :let [row-keys (->> report-data-map
                                        (first)
                                        (second)
                                        :data
                                        (map first)
                                        (filter (fn [k]
                                                  (or (not (number? k))
                                                      (let [entity (get @session/entities k)]
                                                        (and entity (not (:common/disabled? entity)))))))
                                        (sort-by (fn [k]
                                                   (cond
                                                     (string? k) (if (empty? k) "\uFFFF" k)
                                                     (number? k) (let [entity (get @session/entities k)
                                                                       ord (:common/ord entity)]
                                                                   (or ord (entity/display-string entity) k))
                                                     :else k))))
                          _ (swap! export-atom concat [[(loc/tr report-key)]])]]
                [:tbody
                 {:key (str "report-section-" report-key)}
                 [:tr {:key (str "report-" report-key)}
                  [:td {:key        (str "report-title-" report-key)
                        :class-name (fu/cs "bgr-light-grey")
                        :col-span   (inc (count quarter-names))}
                   (loc/tr report-key)]]
                 (doall (->> row-keys
                             (map (fn [kn]
                                    (let [row-name (cond
                                                     (string? kn) kn
                                                     (number? kn) (let [entity (get @session/entities kn)]
                                                                    (or (entity/display-string entity) kn))
                                                     (keyword? kn) (loc/tr kn)
                                                     :else kn)
                                          row-export-atom (atom [row-name])
                                          has-non-zero-values (atom false)
                                          hiccup [:tr
                                                  {:key (str kn "-row")}
                                                  [:td
                                                   {:key (str kn "-heading")}
                                                   row-name]
                                                  (->> quarter-names
                                                       (map (fn [qn]
                                                              (let [cell-string (->> report-data-map
                                                                                     (cu/flip get qn)
                                                                                     :data
                                                                                     (filter (fn [v]
                                                                                               (= (first v) kn)))
                                                                                     (first)
                                                                                     (second) ;; cell-value
                                                                                     (str))
                                                                    hiccup [:td
                                                                            {:key        (str qn "-" kn "-value")
                                                                             :class-name (fu/cs "cell-value")}
                                                                            cell-string]]
                                                                (when (not (or (empty? cell-string)
                                                                               (= cell-string "0")))
                                                                  (reset! has-non-zero-values true))
                                                                (swap! row-export-atom concat [cell-string])
                                                                hiccup)))
                                                       (doall))]]
                                      (when @has-non-zero-values
                                        (swap! export-atom concat [@row-export-atom])
                                        hiccup))))))]))]]]))

(defn view [_]
  (r/create-class
   {:component-did-mount
    (fn [_]
      (doall (map events/fetch-data! reports)))
    :component-will-unmount
    (fn []
      (doall (map events/delete-data! reports)))
    :reagent-render
    (fn [_]
      (let [quarterly-custom-data (events/get-data! :quarterly-data custom-params)
            quarterly-default-data (events/get-data! :quarterly-data default-params)]
        [:div.mb-4
         [report-view "Custom dates" quarterly-custom-data]
         [report-view "Regular dates" quarterly-default-data]]))}))
